export class ProjectsDashboardDb {
    public static projects = [
        /* {
            'name': 'ACME Corp. Backend App'
        },
        {
            'name': 'ACME Corp. Frontend App'
        },
        {
            'name': 'Creapond'
        },
        {
            'name': 'Withinpixels'
        }*/
    ];

    public static widgets = {
        'widget1'      : {
            'title' : 'Tasks',
            'data'  : {
                'label': 'PROCESSES',
                'count': 26,
                'extra': {
                    'label': 'Yesterday\'s overdue',
                    'count': 2
                }
            },
            'detail': 'You can show some detailed information about this widget in here.'
        },
        'widget2'      : {
            'title' : 'Students',
            'data'  : {
                'label': 'STUDENTS',
                'count': '2057k',
                'extra': {
                    'label': 'Yesterday\'s overdue',
                    'count': 2
                }
            },
            'detail': 'You can show some detailed information about this widget in here.'
        },
        'widget3'      : {
            'title' : 'Teachers',
            'data'  : {
                'label': 'TEACHERS',
                'count': '17k',
                'extra': {
                    'label': 'Closed today',
                    'count': 0
                }
            },
            'detail': 'You can show some detailed information about this widget in here.'
        },
        'widget4'      : {
            'title' : 'Issues',
            'data'  : {
                'label': 'ERRORS',
                'count': 42,
                'extra': {
                    'label': 'Warnings',
                    'count': 8
                }
            },
            'detail': 'You can show some detailed information about this widget in here.'
        },
        'widget5'      : {
            'title'     : 'Total Students',
            'ranges'    : {
                'TW': 'This Week',
                'LW': 'Last Week',
                '2W': '2 Weeks Ago'
            },
            'studentsTotal' : [{
                'name'  : 'Total Students',
                'series': [
                    {
                        'name' : '2011',
                        'value': 2020137
                    },
                    {
                        'name' : '2012',
                        'value': 2021239
                    },
                    {
                        'name' : '2013',
                        'value': 2028230
                    },
                    {
                        'name' : '2014',
                        'value': 2031230
                    },
                    {
                        'name' : '2015',
                        'value': 2034230
                    },
                    {
                        'name' : '2016',
                        'value': 2042130
                    },
                    {
                        'name' : '2017',
                        'value': 2057647
                    }
                ]
            }],
            'supporting': {
                'ad'  : {
                    'label': 'Active Directory',
                    'count': {
                        '2W': 230123,
                        'LW': 100123,
                        'TW': 130023
                    },
                    'chart': {
                        '2W': [
                            {
                                'name'  : 'Active Directory',
                                'series': [
                                    {
                                        'name' : '2011',
                                        'value': 98345
                                    },
                                    {
                                        'name' : '2012',
                                        'value': 110456
                                    },
                                    {
                                        'name' : '2013',
                                        'value': 112567
                                    },
                                    {
                                        'name' : '2014',
                                        'value': 119375
                                    },
                                    {
                                        'name' : '2015',
                                        'value': 220444
                                    },
                                    {
                                        'name' : '2016',
                                        'value': 225455
                                    },
                                    {
                                        'name' : '2017',
                                        'value': 230123
                                    }
                                ]
                            }
                        ],
                        'LW': [
                            {
                                'name'  : 'Created',
                                'series': [
                                    {
                                        'name' : 'Mon',
                                        'value': 6
                                    },
                                    {
                                        'name' : 'Tue',
                                        'value': 3
                                    },
                                    {
                                        'name' : 'Wed',
                                        'value': 7
                                    },
                                    {
                                        'name' : 'Thu',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Fri',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Sat',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Sun',
                                        'value': 7
                                    }
                                ]
                            }
                        ],
                        'TW': [
                            {
                                'name'  : 'Created',
                                'series': [
                                    {
                                        'name' : 'Mon',
                                        'value': 3
                                    },
                                    {
                                        'name' : 'Tue',
                                        'value': 2
                                    },
                                    {
                                        'name' : 'Wed',
                                        'value': 1
                                    },
                                    {
                                        'name' : 'Thu',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Fri',
                                        'value': 8
                                    },
                                    {
                                        'name' : 'Sat',
                                        'value': 8
                                    },
                                    {
                                        'name' : 'Sun',
                                        'value': 4
                                    }
                                ]
                            }
                        ]
                    }
                },
                'skyward'   : {
                    'label': 'Skyward',
                    'count': {
                        '2W': 389333,
                        'LW': 31,
                        'TW': 26
                    },
                    'chart': {
                        '2W': [
                            {
                                'name'  : 'Skyward',
                                'series': [
                                    {
                                        'name' : '2011',
                                        'value': 198345
                                    },
                                    {
                                        'name' : '2012',
                                        'value': 210456
                                    },
                                    {
                                        'name' : '2013',
                                        'value': 212567
                                    },
                                    {
                                        'name' : '2014',
                                        'value': 219375
                                    },
                                    {
                                        'name' : '2015',
                                        'value': 320444
                                    },
                                    {
                                        'name' : '2016',
                                        'value': 325455
                                    },
                                    {
                                        'name' : '2017',
                                        'value': 389333
                                    }
                                ]
                            }
                        ],
                        'LW': [
                            {
                                'name'  : 'CLOSED',
                                'series': [
                                    {
                                        'name' : 'Mon',
                                        'value': 6
                                    },
                                    {
                                        'name' : 'Tue',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Wed',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Thu',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Fri',
                                        'value': 7
                                    },
                                    {
                                        'name' : 'Sat',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Sun',
                                        'value': 7
                                    }
                                ]
                            }
                        ],
                        'TW': [
                            {
                                'name'  : 'CLOSED',
                                'series': [
                                    {
                                        'name' : 'Mon',
                                        'value': 6
                                    },
                                    {
                                        'name' : 'Tue',
                                        'value': 3
                                    },
                                    {
                                        'name' : 'Wed',
                                        'value': 7
                                    },
                                    {
                                        'name' : 'Thu',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Fri',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Sat',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Sun',
                                        'value': 7
                                    }
                                ]
                            }
                        ]
                    }
                },
                'powerSchool' : {
                    'label': 'PowerSchool',
                    'count': {
                        '2W': 1023045,
                        'LW': 5,
                        'TW': 2
                    },
                    'chart': {
                        '2W': [
                            {
                                'name'  : 'PowerSchool',
                                'series': [
                                    {
                                        'name' : '2011',
                                        'value': 498345
                                    },
                                    {
                                        'name' : '2012',
                                        'value': 410456
                                    },
                                    {
                                        'name' : '2013',
                                        'value': 412567
                                    },
                                    {
                                        'name' : '2014',
                                        'value': 419375
                                    },
                                    {
                                        'name' : '2015',
                                        'value': 800444
                                    },
                                    {
                                        'name' : '2016',
                                        'value': 805455
                                    },
                                    {
                                        'name' : '2017',
                                        'value': 1023045
                                    }
                                ]
                            }
                        ],
                        'LW': [
                            {
                                'name'  : 'RE-OPENED',
                                'series': [
                                    {
                                        'name' : 'Mon',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Tue',
                                        'value': 7
                                    },
                                    {
                                        'name' : 'Wed',
                                        'value': 8
                                    },
                                    {
                                        'name' : 'Thu',
                                        'value': 8
                                    },
                                    {
                                        'name' : 'Fri',
                                        'value': 6
                                    },
                                    {
                                        'name' : 'Sat',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Sun',
                                        'value': 1
                                    }
                                ]
                            }
                        ],
                        'TW': [
                            {
                                'name'  : 'RE-OPENED',
                                'series': [
                                    {
                                        'name' : 'Mon',
                                        'value': 3
                                    },
                                    {
                                        'name' : 'Tue',
                                        'value': 2
                                    },
                                    {
                                        'name' : 'Wed',
                                        'value': 1
                                    },
                                    {
                                        'name' : 'Thu',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Fri',
                                        'value': 8
                                    },
                                    {
                                        'name' : 'Sat',
                                        'value': 8
                                    },
                                    {
                                        'name' : 'Sun',
                                        'value': 4
                                    }
                                ]
                            }
                        ]
                    }
                },
                'google'  : {
                    'label': 'Google Classroom',
                    'count': {
                        '2W': 901233,
                        'LW': 3,
                        'TW': 4
                    },
                    'chart': {
                        '2W': [
                            {
                                'name'  : 'Google Classroom',
                                'series': [
                                    {
                                        'name' : '2011',
                                        'value': 198345
                                    },
                                    {
                                        'name' : '2012',
                                        'value': 210456
                                    },
                                    {
                                        'name' : '2013',
                                        'value': 212567
                                    },
                                    {
                                        'name' : '2014',
                                        'value': 319375
                                    },
                                    {
                                        'name' : '2015',
                                        'value': 700444
                                    },
                                    {
                                        'name' : '2016',
                                        'value': 705455
                                    },
                                    {
                                        'name' : '2017',
                                        'value': 901233
                                    }
                                ]
                            }
                        ],
                        'LW': [
                            {
                                'name'  : 'WON\'T FIX',
                                'series': [
                                    {
                                        'name' : 'Mon',
                                        'value': 6
                                    },
                                    {
                                        'name' : 'Tue',
                                        'value': 3
                                    },
                                    {
                                        'name' : 'Wed',
                                        'value': 7
                                    },
                                    {
                                        'name' : 'Thu',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Fri',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Sat',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Sun',
                                        'value': 7
                                    }
                                ]
                            }
                        ],
                        'TW': [
                            {
                                'name'  : 'WON\'T FIX',
                                'series': [
                                    {
                                        'name' : 'Mon',
                                        'value': 6
                                    },
                                    {
                                        'name' : 'Tue',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Wed',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Thu',
                                        'value': 5
                                    },
                                    {
                                        'name' : 'Fri',
                                        'value': 7
                                    },
                                    {
                                        'name' : 'Sat',
                                        'value': 4
                                    },
                                    {
                                        'name' : 'Sun',
                                        'value': 7
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        },
        'widget6'      : {
            'title'      : 'Student\'s with email',
            'ranges'     : {
                'TW': 'This Week',
                'LW': 'Last Week',
                '2W': '2 Weeks Ago'
            },
            'mainChart'  : {
                'TW': [
                    {
                        'name' : 'with email',
                        'value': 82
                    },
                    {
                        'name' : 'without email',
                        'value': 18
                    }
                ],
                'LW': [
                    {
                        'name' : 'with email',
                        'value': 62
                    },
                    {
                        'name' : 'without email',
                        'value': 8
                    }
                ],
                '2W': [
                    {
                        'name' : 'with email',
                        'value': 82
                    },
                    {
                        'name' : 'without email',
                        'value': 18
                    }
                ]
            },
            'footerLeft' : {
                'title': 'With Email',
                'count': {
                    '2W': 144,
                    'LW': 62,
                    'TW': 82
                }
            },
            'footerRight': {
                'title': 'Without Email',
                'count': {
                    '2W': 26,
                    'LW': 8,
                    'TW': 18
                }
            }
        },
        'widget7'      : {
            'title'     : 'Issues',
            'ranges'    : {
                'TW': 'This Week',
                'LW': 'Last Week',
                '2W': '2 Weeks Ago'
            },
            'mainChart' : {
                '2W': [
                    {
                        'name'  : '01/16',
                        'series': [
                            {'name' : 'errors', 'value': 37},
                            {'name' : 'warnings', 'value': 9}
                        ]
                    },
                    {
                        'name'  : '01/17',
                        'series': [
                            {'name' : 'errors', 'value': 112},
                            {'name' : 'warnings', 'value': 29}
                        ]
                    },
                    {
                        'name'  : '01/18',
                        'series': [
                            {'name' : 'errors', 'value': 22},
                            {'name' : 'warnings', 'value': 19}
                        ]
                    },
                    {
                        'name'  : '01/19',
                        'series': [
                            {'name' : 'errors', 'value': 236},
                            {'name' : 'warnings', 'value': 5}
                        ]
                    },
                    {
                        'name'  : '01/20',
                        'series': [
                            {'name' : 'errors', 'value': 220},
                            {'name' : 'warnings', 'value': 49}
                        ]
                    },
                    {
                        'name'  : '01/21',
                        'series': [
                            {'name' : 'errors', 'value': 290},
                            {'name' : 'warnings', 'value': 39}
                        ]
                    },
                    {
                        'name'  : '01/22',
                        'series': [
                            {'name' : 'errors', 'value': 377},
                            {'name' : 'warnings', 'value': 149}
                        ]
                    },
                    {
                        'name'  : '01/23',
                        'series': [
                            {'name' : 'errors', 'value': 37},
                            {'name' : 'warnings', 'value': 119}
                        ]
                    },
                    {
                        'name'  : '01/24',
                        'series': [
                            {'name' : 'errors', 'value': 15},
                            {'name' : 'warnings', 'value': 119}
                        ]
                    },
                    {
                        'name'  : '01/25',
                        'series': [
                            {'name' : 'errors', 'value': 237},
                            {'name' : 'warnings', 'value': 209}
                        ]
                    },
                    {
                        'name'  : '01/26',
                        'series': [
                            {'name' : 'errors', 'value': 37},
                            {'name' : 'warnings', 'value': 234}
                        ]
                    },
                    {
                        'name'  : '01/27',
                        'series': [
                            {'name' : 'errors', 'value': 110},
                            {'name' : 'warnings', 'value': 145}
                        ]
                    },
                    {
                        'name'  : '01/28',
                        'series': [
                            {'name' : 'errors', 'value': 162},
                            {'name' : 'warnings', 'value': 150}
                        ]
                    },
                    {
                        'name'  : '01/29',
                        'series': [
                            {'name' : 'errors', 'value': 20},
                            {'name' : 'warnings', 'value': 9}
                        ]
                    }
                ],
                'LW': [
                    {
                        'name'  : '01/16',
                        'series': [
                            {'name' : 'errors', 'value': 37},
                            {'name' : 'warnings', 'value': 9}
                        ]
                    },
                    {
                        'name'  : '01/17',
                        'series': [
                            {'name' : 'errors', 'value': 112},
                            {'name' : 'warnings', 'value': 29}
                        ]
                    },
                    {
                        'name'  : '01/18',
                        'series': [
                            {'name' : 'errors', 'value': 22},
                            {'name' : 'warnings', 'value': 19}
                        ]
                    },
                    {
                        'name'  : '01/19',
                        'series': [
                            {'name' : 'errors', 'value': 236},
                            {'name' : 'warnings', 'value': 5}
                        ]
                    },
                    {
                        'name'  : '01/20',
                        'series': [
                            {'name' : 'errors', 'value': 220},
                            {'name' : 'warnings', 'value': 49}
                        ]
                    },
                    {
                        'name'  : '01/21',
                        'series': [
                            {'name' : 'errors', 'value': 290},
                            {'name' : 'warnings', 'value': 39}
                        ]
                    },
                    {
                        'name'  : '01/22',
                        'series': [
                            {'name' : 'errors', 'value': 377},
                            {'name' : 'warnings', 'value': 149}
                        ]
                    }
                ],
                'TW': [
                    {
                        'name'  : '01/23',
                        'series': [
                            {'name' : 'errors', 'value': 37},
                            {'name' : 'warnings', 'value': 119}
                        ]
                    },
                    {
                        'name'  : '01/24',
                        'series': [
                            {'name' : 'errors', 'value': 15},
                            {'name' : 'warnings', 'value': 119}
                        ]
                    },
                    {
                        'name'  : '01/25',
                        'series': [
                            {'name' : 'errors', 'value': 237},
                            {'name' : 'warnings', 'value': 209}
                        ]
                    },
                    {
                        'name'  : '01/26',
                        'series': [
                            {'name' : 'errors', 'value': 37},
                            {'name' : 'warnings', 'value': 234}
                        ]
                    },
                    {
                        'name'  : '01/27',
                        'series': [
                            {'name' : 'errors', 'value': 110},
                            {'name' : 'warnings', 'value': 145}
                        ]
                    },
                    {
                        'name'  : '01/28',
                        'series': [
                            {'name' : 'errors', 'value': 162},
                            {'name' : 'warnings', 'value': 150}
                        ]
                    },
                    {
                        'name'  : '01/29',
                        'series': [
                            {'name' : 'errors', 'value': 20},
                            {'name' : 'warnings', 'value': 9}
                        ]
                    }
                ]
            }
        },
        'widget8'      : {
            'title'     : 'Entities Import',
            'ranges'    : {
                'TW': 'This Week',
                'LW': 'Last Week',
                '2W': '2 Weeks Ago'
            },
            'mainChart' : {
                '2W': [
                    {'name'  : '01/16', 'value': 137},
                    {'name'  : '01/17', 'value': 2301},
                    {'name'  : '01/18', 'value': 445},
                    {'name'  : '01/19', 'value': 564},
                    {'name'  : '01/20', 'value': 23},
                    {'name'  : '01/21', 'value': 4537},
                    {'name'  : '01/22', 'value': 943},

                    {'name'  : '01/23', 'value': 30},
                    {'name'  : '01/24', 'value': 358},
                    {'name'  : '01/25', 'value': 9654},
                    {'name'  : '01/26', 'value': 3344},
                    {'name'  : '01/27', 'value': 3446},
                    {'name'  : '01/28', 'value': 566},
                    {'name'  : '01/29', 'value': 788}
                ],
                'LW': [
                    {'name'  : '01/16', 'value': 137},
                    {'name'  : '01/17', 'value': 2301},
                    {'name'  : '01/18', 'value': 445},
                    {'name'  : '01/19', 'value': 564},
                    {'name'  : '01/20', 'value': 23},
                    {'name'  : '01/21', 'value': 4537},
                    {'name'  : '01/22', 'value': 943}
                ],
                'TW': [
                    {'name'  : '01/23', 'value': 30},
                    {'name'  : '01/24', 'value': 358},
                    {'name'  : '01/25', 'value': 9654},
                    {'name'  : '01/26', 'value': 3344},
                    {'name'  : '01/27', 'value': 3446},
                    {'name'  : '01/28', 'value': 566},
                    {'name'  : '01/29', 'value': 788}
                ]
            }
        },

        'widget9'      : {
            'title'         : 'Spent',
            'ranges'        : {
                'TW': 'This Week',
                'LW': 'Last Week',
                '2W': '2 Weeks Ago'
            },
            'weeklySpent'   : {
                'title': 'WEEKLY SPENT',
                'count': {
                    '2W': '2,682.85',
                    'LW': '1,445.34',
                    'TW': '3,630.15'
                },
                'chart': {
                    '2W': [
                        {
                            'name'  : 'CREATED',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 6
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 1
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 3
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 4
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 5
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 5
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 2
                                }
                            ]
                        }
                    ],
                    'LW': [
                        {
                            'name'  : 'Created',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 4
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 6
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 2
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 2
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 1
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 3
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 4
                                }
                            ]
                        }
                    ],
                    'TW': [
                        {
                            'name'  : 'Created',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 2
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 6
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 5
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 4
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 5
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 3
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 6
                                }
                            ]
                        }
                    ]
                }
            },
            'totalSpent'    : {
                'title': 'TOTAL SPENT',
                'count': {
                    '2W': '29,682.85',
                    'LW': '31,128.19',
                    'TW': '34,758.34'
                },
                'chart': {
                    '2W': [
                        {
                            'name'  : 'CREATED',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 3
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 2
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 2
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 4
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 7
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 7
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 4
                                }
                            ]
                        }
                    ],
                    'LW': [
                        {
                            'name'  : 'Created',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 5
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 7
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 8
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 8
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 6
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 4
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 1
                                }
                            ]
                        }
                    ],
                    'TW': [
                        {
                            'name'  : 'Created',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 6
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 4
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 7
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 5
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 5
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 4
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 7
                                }
                            ]
                        }
                    ]
                }
            },
            'remaining'     : {
                'title': 'REMAINING',
                'count': {
                    '2W': '94.317,15',
                    'LW': '92.871,81',
                    'TW': '89.241,66'
                },
                'chart': {
                    '2W': [
                        {
                            'name'  : 'CREATED',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 1
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 4
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 5
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 7
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 8
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 2
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 4
                                }
                            ]
                        }
                    ],
                    'LW': [
                        {
                            'name'  : 'Created',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 3
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 2
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 1
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 4
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 8
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 8
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 4
                                }
                            ]
                        }
                    ],
                    'TW': [
                        {
                            'name'  : 'Created',
                            'series': [
                                {
                                    'name' : 'Mon',
                                    'value': 2
                                },
                                {
                                    'name' : 'Tue',
                                    'value': 4
                                },
                                {
                                    'name' : 'Wed',
                                    'value': 8
                                },
                                {
                                    'name' : 'Thu',
                                    'value': 6
                                },
                                {
                                    'name' : 'Fri',
                                    'value': 2
                                },
                                {
                                    'name' : 'Sat',
                                    'value': 5
                                },
                                {
                                    'name' : 'Sun',
                                    'value': 1
                                }
                            ]
                        }
                    ]
                }
            },
            'totalRemaining': {
                'title': 'TOTAL BUDGET',
                'count': '124.000,00'
            },
            'totalBudget'   : {
                'title': 'TOTAL BUDGET',
                'count': '124.000,00'
            }
        },
        'widget10'     : {
            'title': 'Budget Details',
            'table': {
                'columns': [
                    {
                        'title': 'Budget Type'
                    },
                    {
                        'title': 'Total Budget'
                    },
                    {
                        'title': 'Spent ($)'
                    },
                    {
                        'title': 'Spent (%)'
                    },
                    {
                        'title': 'Remaining ($)'
                    },
                    {
                        'title': 'Remaining (%)'
                    }
                ],
                'rows'   : [
                    [
                        {
                            'value'  : 'Wireframing',
                            'classes': 'mat-primary-bg',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$14,880.00',
                            'classes': 'text-bold',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$14,000.00',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%94.08',
                            'classes': 'text-success',
                            'icon'   : 'trending_up'
                        },
                        {
                            'value'  : '$880.00',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%5.92',
                            'classes': '',
                            'icon'   : ''
                        }
                    ],
                    [
                        {
                            'value'  : 'Design',
                            'classes': 'mat-green-bg',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$21,080.00',
                            'classes': 'text-bold',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$17,240.34',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%81.78',
                            'classes': 'text-success',
                            'icon'   : 'trending_up'
                        },
                        {
                            'value'  : '$3,839.66',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%18.22',
                            'classes': '',
                            'icon'   : ''
                        }
                    ],
                    [
                        {
                            'value'  : 'Coding',
                            'classes': 'mat-red-bg',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$34,720.00',
                            'classes': 'text-bold',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$3,518.00',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%10.13',
                            'classes': 'text-danger',
                            'icon'   : 'trending_down'
                        },
                        {
                            'value'  : '$31,202.00',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%89.87',
                            'classes': '',
                            'icon'   : ''
                        }
                    ],
                    [
                        {
                            'value'  : 'Marketing',
                            'classes': 'mat-accent-bg',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$34,720.00',
                            'classes': 'text-bold',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$0.00',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%0.00',
                            'classes': 'text-info',
                            'icon'   : 'trending_flat'
                        },
                        {
                            'value'  : '$34,720.00',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%100.00',
                            'classes': '',
                            'icon'   : ''
                        }
                    ],
                    [
                        {
                            'value'  : 'Extra',
                            'classes': 'mat-orange-bg',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$18,600.00',
                            'classes': 'text-bold',
                            'icon'   : ''
                        },
                        {
                            'value'  : '$0.00',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%0.00',
                            'classes': 'text-info',
                            'icon'   : 'trending_flat'
                        },
                        {
                            'value'  : '$34,720.00',
                            'classes': '',
                            'icon'   : ''
                        },
                        {
                            'value'  : '%100.00',
                            'classes': '',
                            'icon'   : ''
                        }
                    ]
                ]
            }
        },
        'widget11'     : {
            'title': 'Team Members',
            'table': {
                'columns': ['avatar', 'name', 'position', 'office', 'email', 'phone'],
                'rows'   : [
                    /* {
                        avatar  : 'assets/images/avatars/james.jpg',
                        name    : 'Jack Gilbert',
                        position: 'Design Manager',
                        office  : 'Johor Bahru',
                        email   : 'jgilbert48@mail.com',
                        phone   : '+16 298 032 7774'
                    },
                    {
                        avatar  : 'assets/images/avatars/katherine.jpg',
                        name    : 'Kathy Anderson',
                        position: 'Recruiting Manager',
                        office  : 'Solţānābād',
                        email   : 'kanderson49@mail.com.br',
                        phone   : '+23 572 311 1136'
                    },
                    {
                        avatar  : 'assets/images/avatars/andrew.jpg',
                        name    : 'Mark Turner',
                        position: 'Recruiting Manager',
                        office  : 'Neftegorsk',
                        email   : 'mturner4a@mail.com',
                        phone   : '+01 139 803 9263'
                    },
                    {
                        avatar  : 'assets/images/avatars/jane.jpg',
                        name    : 'Kathryn Martinez',
                        position: 'Director of Sales',
                        office  : 'Palekastro',
                        email   : 'kmartinez4b@mail.com',
                        phone   : '+25 467 022 5393'
                    },
                    {
                        avatar  : 'assets/images/avatars/alice.jpg',
                        name    : 'Annie Gonzales',
                        position: 'Actuary',
                        office  : 'Candon',
                        email   : 'agonzales4c@mail.edu',
                        phone   : '+99 891 619 7138'
                    },
                    {
                        avatar  : 'assets/images/avatars/vincent.jpg',
                        name    : 'Howard King',
                        position: 'Human Resources',
                        office  : 'Bergen op Zoom',
                        email   : 'hking4d@mail.gov',
                        phone   : '+46 984 348 1409'
                    },
                    {
                        avatar  : 'assets/images/avatars/joyce.jpg',
                        name    : 'Elizabeth Dixon',
                        position: 'Electrical Engineer',
                        office  : 'Písečná',
                        email   : 'edixon4e@mail.gov',
                        phone   : '+33 332 067 9063'
                    },
                    {
                        avatar  : 'assets/images/avatars/danielle.jpg',
                        name    : 'Dorothy Morris',
                        position: 'Office Assistant',
                        office  : 'Magsaysay',
                        email   : 'dmorris4f@mail.com',
                        phone   : '+05 490 958 6120'
                    },
                    {
                        avatar  : 'assets/images/avatars/carl.jpg',
                        name    : 'Mark Gonzales',
                        position: 'Quality Control',
                        office  : 'Matsue-shi',
                        email   : 'mgonzales4g@mail.com',
                        phone   : '+03 168 394 9935'
                    },
                    {
                        avatar  : 'assets/images/avatars/profile.jpg',
                        name    : 'Catherine Rogers',
                        position: 'Programmer Analyst',
                        office  : 'Kangar',
                        email   : 'crogers4h@mail.com',
                        phone   : '+86 235 407 5373'
                    },
                    {
                        avatar  : 'assets/images/avatars/garry.jpg',
                        name    : 'Ruth Grant',
                        position: 'Community Outreach',
                        office  : 'Beaune',
                        email   : 'rgrant4i@mail.pl',
                        phone   : '+36 288 083 8460'
                    },
                    {
                        avatar  : 'assets/images/avatars/james.jpg',
                        name    : 'Phyllis Gutierrez',
                        position: 'Administrative Assistant',
                        office  : 'Shlissel’burg',
                        email   : 'pgutierrez4j@mail.net',
                        phone   : '+52 749 861 9304'
                    }, {
                        avatar  : 'assets/images/avatars/alice.jpg',
                        name    : 'Lillian Morris',
                        position: 'Media Planner',
                        office  : 'Berlin',
                        email   : 'lmorris4k@mail.de',
                        phone   : '+59 695 110 3856'
                    }, {
                        avatar  : 'assets/images/avatars/vincent.jpg',
                        name    : 'Jeremy Anderson',
                        position: 'Systems Engineer',
                        office  : 'Lũng Hồ',
                        email   : 'janderson4l@mail.uk',
                        phone   : '+40 384 115 1448'
                    },
                    {
                        avatar  : 'assets/images/avatars/carl.jpg',
                        name    : 'Arthur Lawrence',
                        position: 'Nurse Practicioner',
                        office  : 'Sarkanjut',
                        email   : 'alawrence4m@mail.com',
                        phone   : '+36 631 599 7867'
                    }, {
                        avatar  : 'assets/images/avatars/andrew.jpg',
                        name    : 'David Simmons',
                        position: 'Social Worker',
                        office  : 'Ushumun',
                        email   : 'dsimmons4n@mail.com',
                        phone   : '+01 189 681 4417'
                    }, {
                        avatar  : 'assets/images/avatars/danielle.jpg',
                        name    : 'Daniel Johnston',
                        position: 'Help Desk',
                        office  : 'São Carlos',
                        email   : 'djohnston4o@mail.gov',
                        phone   : '+60 028 943 7919'
                    },

                    {
                        avatar  : 'assets/images/avatars/joyce.jpg',
                        name    : 'Ann King',
                        position: 'Internal Auditor',
                        office  : 'Liren',
                        email   : 'aking4p@mail.com',
                        phone   : '+91 103 932 6545'
                    },
                    {
                        avatar  : 'assets/images/avatars/james.jpg',
                        name    : 'Phillip Franklin',
                        position: 'VP Accounting',
                        office  : 'Soba',
                        email   : 'pfranklin4q@mail.com',
                        phone   : '+25 820 986 7626'
                    },
                    {
                        avatar  : 'assets/images/avatars/garry.jpg',
                        name    : 'Gary Gonzalez',
                        position: 'Speech Pathologist',
                        office  : 'Gangkou',
                        email   : 'ggonzalez4r@mail.cc',
                        phone   : '+10 862 046 7916'
                    }*/
                ]
            }
        },
        'weatherWidget': {
            'locations'      : {
                'NewYork': {
                    'name'           : 'New York',
                    'icon'           : 'icon-rainy2',
                    'temp'           : {
                        'C': '22',
                        'F': '72'
                    },
                    'windSpeed'      : {
                        'KMH': 12,
                        'MPH': 7.5
                    },
                    'windDirection'  : 'NW',
                    'rainProbability': '98%',
                    'next3Days'      : [
                        {
                            'name': 'Sunday',
                            'icon': 'icon-rainy',
                            'temp': {
                                'C': '21',
                                'F': '70'
                            }
                        },
                        {
                            'name': 'Sunday',
                            'icon': 'icon-cloudy',
                            'temp': {
                                'C': '19',
                                'F': '66'
                            }
                        },
                        {
                            'name': 'Tuesday',
                            'icon': 'icon-windy3',
                            'temp': {
                                'C': '24',
                                'F': '75'
                            }
                        }
                    ]
                }
            },
            'currentLocation': 'NewYork',
            'tempUnit'       : 'C',
            'speedUnit'      : 'KMH'
        }
    };
}
